import { DEMO_SCHEDULES } from '@/data/pulseDemo/demoSchedules'
import { nextCronRun, prevCronRun } from './cronOccurrences'
import { localTimezone } from './localTimezone'

const latestRunAt = (runs, id) => runs.find((run) => run.sourceId === id)?.at ?? 0
const iso = (ms) => (ms ? new Date(ms).toISOString() : null)

/**
 * Sample schedules with the user's edits applied, in the shape the schedule
 * list and details panel read. Run times are computed from the cron each time,
 * so the list never shows a stale date.
 */
export function buildDemoSchedules({ overrides, runs }, now = Date.now()) {
  return DEMO_SCHEDULES.filter((item) => !overrides[item.id]?.deleted).map((item) => {
    const row = { ...item, ...overrides[item.id] }
    const enabled = row.enabled !== false
    const status = enabled ? 'active' : 'paused'
    const lastRun = Math.max(prevCronRun(row.cron, now)?.getTime() ?? 0, latestRunAt(runs, item.id))
    return {
      id: item.id,
      objectType: 'demo',
      title: row.title,
      cron: row.cron,
      timezone: row.timezone || localTimezone(),
      scheduleEnabled: enabled,
      status,
      triggerStatus: status,
      nextRunAt: enabled ? iso(nextCronRun(row.cron, now)?.getTime()) : null,
      lastRunAt: iso(lastRun),
      description: row.goal,
      spec: { goal: row.goal },
      apps: item.apps,
    }
  })
}
